"use client";

import useLocaleRouter from "@/hooks/useLocaleRouter";
import { useScopedI18n } from "@/messages/client";
import { Search } from "lucide-react";
import { useState } from "react";

export default function SearchInput() {
  const t = useScopedI18n("页脚");

  const [search, setSearch] = useState("");

  const router = useLocaleRouter();

  return (
    <>
      <div className="relative hidden h-11 w-72 items-center rounded-sm border-2 border-[#A6A6A6] transition-colors duration-300 hover:border-white focus:border-white md:flex lg:w-[380px] xl:w-[460px]">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              router.push(`/global-search?keyword=${search}`, {
                scroll: false,
              });
            }
          }}
          className="h-full flex-1 border-none bg-transparent px-5 text-white outline-none placeholder:text-[#A6A6A6]"
          placeholder={t("pc搜索提示")}
        />

        <div
          className="relative flex h-full flex-shrink-0 cursor-pointer items-center px-4 text-[#A6A6A6] transition-colors duration-300 before:absolute before:left-0 before:top-1/2 before:h-4/5 before:w-px before:-translate-y-1/2 before:bg-[#A6A6A6] hover:text-white"
          onClick={() => {
            router.push(`/global-search?keyword=${search}`, {
              scroll: false,
            });
          }}>
          <Search size={20} />
        </div>
      </div>

      <div
        onClick={() => {
          router.push(`/global-search`);
        }}
        className="flex flex-1 items-center justify-center space-x-2 rounded-full border border-[#A6A6A6] px-4 py-2.5 text-sm text-[#E5E5E5] md:hidden">
        <Search size={20} />

        <span className="text-sm">{t("搜索")}</span>
      </div>
    </>
  );
}
